import { useDispatch } from 'react-redux';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { getLoginUrl } from '../http-login/getLoginUrl';
import { redirectToUrl } from '../utils/redirectToUrl';
export const useLoginRedirect = () => {
  const dispatch = useDispatch();
  const redirectToLogin = ({
    redirectUrl = '',
    email = '',
    hublet = HubletOption.na1
  } = {}) => {
    dispatch(redirectToUrl(getLoginUrl({
      redirectUrl,
      email,
      hublet
    })));
  };
  return {
    redirectToLogin
  };
};